export const css = `body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif
}
.donotprint{
    visibility:hidden;
}
code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, Courier New, monospace
}

/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/
*,
:after,
:before {
    border: 0 solid #e5e7eb;
    box-sizing: border-box
}

:after,
:before {
    --tw-content: ""
}

html {
    -webkit-text-size-adjust: 100%;
    -webkit-font-feature-settings: normal;
    font-feature-settings: normal;
    font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
    font-variation-settings: normal;
    line-height: 1.5;
    tab-size: 4
}

body {
    line-height: inherit;
    margin: 0;
    background: none !important;
}

hr {
    border-top-width: 1px;
    color: inherit;
    height: 0
}

.qno{
    background: #8E84FF;
}

.leftspace{
    margin-left: 2.5rem;
}
.spacearound{
    margin:2.5rem;
}
abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted
}

h1,
h2,
h3,
h4,
h5,
h6 {
    font-size: inherit;
    font-weight: inherit
}

a {
    color: inherit;
    text-decoration: inherit
}

b,
strong {
    font-weight: bolder
}

code,
kbd,
pre,
samp {
    font-family: Roboto Mono, serif;
    font-size: 1em
}

small {
    font-size: 80%
}

sub,
sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: initial
}

sub {
    bottom: -.25em
}

sup {
    top: -.5em
}

table {
    border-collapse: collapse;
    border-color: inherit;
    text-indent: 0
}

button,
input,
optgroup,
select,
textarea {
    -webkit-font-feature-settings: inherit;
    font-feature-settings: inherit;
    color: inherit;
    font-family: inherit;
    font-size: 100%;
    font-variation-settings: inherit;
    font-weight: inherit;
    line-height: inherit;
    margin: 0;
    padding: 0
}

button,
select {
    text-transform: none
}

[type=button],
[type=reset],
[type=submit],
button {
    -webkit-appearance: button;
    background-color: initial;
    background-image: none
}

:-moz-focusring {
    outline: auto
}

:-moz-ui-invalid {
    box-shadow: none
}

progress {
    vertical-align: initial
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
    height: auto
}

[type=search] {
    -webkit-appearance: textfield;
    outline-offset: -2px
}

::-webkit-search-decoration {
    -webkit-appearance: none
}

::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit
}

summary {
    display: list-item
}

blockquote,
dd,
dl,
figure,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
pre {
    margin: 0
}

fieldset {
    margin: 0
}

fieldset,
legend {
    padding: 0
}

menu,
ol,
ul {
    list-style: none;
    margin: 0;
    padding: 0
}

dialog {
    padding: 0
}

textarea {
    resize: vertical
}

input::-webkit-input-placeholder,
textarea::-webkit-input-placeholder {
    color: #9ca3af;
    opacity: 1
}

input::placeholder,
textarea::placeholder {
    color: #9ca3af;
    opacity: 1
}

[role=button],
button {
    cursor: pointer
}

:disabled {
    cursor: default
}

audio,
canvas,
embed,
iframe,
img,
object,
svg,
video {
    display: block;
    vertical-align: middle
}

img,
video {
    height: auto;
    max-width: 100%
}

[hidden] {
    display: none
}

*,
:after,
:before {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia:
}

::-webkit-backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia:
}

::backdrop {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position: ;
    --tw-gradient-via-position: ;
    --tw-gradient-to-position: ;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(59, 130, 246, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia:
}

.container {
    margin-left: auto;
    margin-right: auto;
    width: 100%
}

@media (min-width:640px) {
    .container {
        max-width: 640px
    }
}

@media (min-width:768px) {
    .container {
        max-width: 768px
    }
}

@media (min-width:1024px) {
    .container {
        max-width: 1024px
    }
}

@media (min-width:1280px) {
    .container {
        max-width: 1280px
    }
}

@media (min-width:1536px) {
    .container {
        max-width: 1536px
    }
}

.sticky {
    position: -webkit-sticky;
    position: sticky
}

.top-0 {
    top: 0
}

.m-4 {
    margin: 1rem
}

.m-5 {
    margin: 1.25rem
}

.m-6 {
    margin: 1.5rem
}

.mx-10 {
    margin-left: 2.5rem;
    margin-right: 2.5rem
}

.mx-4 {
    margin-left: 1rem;
    margin-right: 1rem
}

.mx-8 {
    margin-left: 2rem;
    margin-right: 2rem
}

.mx-auto {
    margin-left: auto;
    margin-right: auto
}

.my-10 {
    margin-bottom: 2.5rem;
    margin-top: 2.5rem
}

.my-2 {
    margin-bottom: .5rem;
    margin-top: .5rem
}

.my-4 {
    margin-bottom: 1rem;
    margin-top: 1rem
}

.my-6 {
    margin-bottom: 1.5rem;
    margin-top: 1.5rem
}

.my-8 {
    margin-bottom: 2rem;
    margin-top: 2rem
}

.mb-2 {
    margin-bottom: .5rem
}

.mb-6 {
    margin-bottom: 1.5rem
}

.ml-10 {
    margin-left: 2.5rem
}

.mt-10 {
    margin-top: 2.5rem
}

.mt-2 {
    margin-top: .5rem
}

.mt-4 {
    margin-top: 1rem
}

.mt-9 {
    margin-top: 2.25rem
}

.block {
    display: block
}

.flex {
    display: flex
}

.hidden {
    display: none
}

.h-1 {
    height: .25rem
}

.h-20 {
    height: 5rem
}

.h-4 {
    height: 1rem
}

.h-[842px] {
    height: 842px
}

.h-full {
    height: 100%
}

.h-screen {
    height: 100vh
}

.w-1/12 {
    width: 8.333333%
}

.w-1/3 {
    width: 33.333333%
}

.w-20 {
    width: 5rem
}

.w-3/4 {
    width: 75%
}

.w-4 {
    width: 1rem
}

.w-5/6 {
    width: 83.333333%
}

.w-[300px] {
    width: 300px
}

.w-[595px] {
    width: 595px
}

.w-[600px] {
    width: 600px
}

.w-full {
    width: 100%
}

.flex-auto {
    flex: 1 1 auto
}

.grow {
    flex-grow: 1
}

.origin-left {
    -webkit-transform-origin: left;
    transform-origin: left
}

@-webkit-keyframes spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

@keyframes spin {
    to {
        -webkit-transform: rotate(1turn);
        transform: rotate(1turn)
    }
}

.animate-spin {
    -webkit-animation: spin 1s linear infinite;
    animation: spin 1s linear infinite
}

.cursor-pointer {
    cursor: pointer
}

.list-[upper-alpha] {
    list-style-type: upper-alpha
}

.appearance-none {
    -webkit-appearance: none;
    appearance: none
}

.flex-col {
    flex-direction: column
}

.items-center {
    align-items: center
}

.justify-start {
    justify-content: flex-start
}

.justify-end {
    justify-content: flex-end
}

.justify-center {
    justify-content: center
}

.justify-between {
    justify-content: space-between
}

.gap-4 {
    gap: 1rem
}

.gap-x-6 {
    -webkit-column-gap: 1.5rem;
    column-gap: 1.5rem
}

.space-x-2>:not([hidden])~:not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-left: calc(.5rem*(1 - var(--tw-space-x-reverse)));
    margin-right: calc(.5rem*var(--tw-space-x-reverse))
}

.overflow-auto {
    overflow: auto
}

.whitespace-nowrap {
    white-space: nowrap
}

.rounded-full {
    border-radius: 9999px
}

.rounded-lg {
    border-radius: .5rem
}

.rounded-md {
    border-radius: .375rem
}

.border {
    border-width: 1px
}

.border-2 {
    border-width: 2px
}

.border-4 {
    border-width: 4px
}

.border-b-2 {
    border-bottom-width: 2px
}

.border-b-4 {
    border-bottom-width: 4px
}

.border-t-2 {
    border-top-width: 2px
}

.border-dashed {
    border-style: dashed
}

.border-[#766AFF] {
    --tw-border-opacity: 1;
    border-color: rgb(118 106 255/var(--tw-border-opacity))
}

.border-[#8E84FF] {
    --tw-border-opacity: 1;
    border-color: rgb(142 132 255/var(--tw-border-opacity))
}

.border-[#E4E1FF] {
    --tw-border-opacity: 1;
    border-color: rgb(228 225 255/var(--tw-border-opacity))
}

.border-gray-200 {
    --tw-border-opacity: 1;
    border-color: rgb(229 231 235/var(--tw-border-opacity))
}

.border-light-purple {
    --tw-border-opacity: 1;
    border-color: rgb(235 234 253/var(--tw-border-opacity))
}

.border-purple {
    --tw-border-opacity: 1;
    border-color: rgb(118 106 255/var(--tw-border-opacity))
}

.bg-[#766AFF] {
    --tw-bg-opacity: 1;
    background-color: rgb(118 106 255/var(--tw-bg-opacity))
}

.bg-[#8E84FF] {
    --tw-bg-opacity: 1;
    background-color: rgb(142 132 255/var(--tw-bg-opacity))
}

.bg-[#C6C4FA] {
    --tw-bg-opacity: 1;
    background-color: rgb(198 196 250/var(--tw-bg-opacity))
}

.bg-[#D2CFF1] {
    --tw-bg-opacity: 1;
    background-color: rgb(210 207 241/var(--tw-bg-opacity))
}

.bg-[#EBEAFD] {
    --tw-bg-opacity: 1;
    background-color: rgb(235 234 253/var(--tw-bg-opacity))
}

.bg-[#ECEEFF] {
    --tw-bg-opacity: 1;
    background-color: rgb(236 238 255/var(--tw-bg-opacity))
}

.bg-[#F4FCFF] {
    --tw-bg-opacity: 1;
    background-color: rgb(244 252 255/var(--tw-bg-opacity))
}

.bg-light-purple {
    --tw-bg-opacity: 1;
    background-color: rgb(235 234 253/var(--tw-bg-opacity))
}

.bg-white {
    --tw-bg-opacity: 1;
    background-color: rgb(255 255 255/var(--tw-bg-opacity))
}

.p-10 {
    padding: 2.5rem
}

.p-2 {
    padding: .5rem
}

.p-2.5 {
    padding: .625rem
}

.p-3 {
    padding: .75rem
}

.p-6 {
    padding: 1.5rem
}

.px-4 {
    padding-left: 1rem;
    padding-right: 1rem
}

.px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem
}

.px-8 {
    padding-left: 2rem;
    padding-right: 2rem
}

.px-[10%] {
    padding-left: 10%;
    padding-right: 10%
}

.px-[5%] {
    padding-left: 5%;
    padding-right: 5%
}

.py-2 {
    padding-bottom: .5rem;
    padding-top: .5rem
}

.py-2.5 {
    padding-bottom: .625rem;
    padding-top: .625rem
}

.py-3 {
    padding-bottom: .75rem;
    padding-top: .75rem
}

.py-4 {
    padding-bottom: 1rem;
    padding-top: 1rem
}

.pb-[500px] {
    padding-bottom: 500px
}

.pe-3 {
    -webkit-padding-end: .75rem;
    padding-inline-end: .75rem
}

.pl-2 {
    padding-left: .5rem
}

.pl-[40px] {
    padding-left: 40px
}

.pl-[45px] {
    padding-left: 45px
}

.pt-3 {
    padding-top: .75rem
}

.text-center {
    text-align: center
}

.font-heading {
    font-family: Archivo, sans-serif
}

.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem
}

.text-base {
    font-size: 1rem;
    line-height: 1.5rem
}

.text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem
}

.text-sm {
    font-size: .875rem;
    line-height: 1.25rem
}

.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem
}

.font-bold {
    font-weight: 700
}

.font-medium {
    font-weight: 500
}

.font-normal {
    font-weight: 400
}

.leading-4 {
    line-height: 1rem
}

.leading-5 {
    line-height: 1.25rem
}

.tracking-wider {
    letter-spacing: .05em
}

.text-black {
    --tw-text-opacity: 1;
    color: rgb(0 0 0/var(--tw-text-opacity))
}

.text-blue-600 {
    --tw-text-opacity: 1;
    color: rgb(37 99 235/var(--tw-text-opacity))
}

.text-gray-600 {
    --tw-text-opacity: 1;
    color: rgb(75 85 99/var(--tw-text-opacity))
}

.text-purple {
    --tw-text-opacity: 1;
    color: rgb(118 106 255/var(--tw-text-opacity))
}

.text-white {
    --tw-text-opacity: 1;
    color: rgb(255 255 255/var(--tw-text-opacity))
}

.shadow-xl {
    --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, .1), 0 8px 10px -6px rgba(0, 0, 0, .1);
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
    box-shadow: 0 0 #0000, 0 0 #0000, var(--tw-shadow);
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)
}

.transition {
    transition-duration: .15s;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, -webkit-transform, -webkit-filter, -webkit-backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-transform, -webkit-filter, -webkit-backdrop-filter;
    transition-timing-function: cubic-bezier(.4, 0, .2, 1)
}

.duration-300 {
    transition-duration: .3s
}

::-webkit-scrollbar {
    background-color: #d2cff1;
    border-radius: 7px;
    width: 14px
}

::-webkit-scrollbar-thumb {
    background-color: #8e84ff;
    border-radius: 7px
}

::-webkit-scrollbar-track:hover {
    background-color: #d2cff1
}

body {
    background-color: #ebeafd
}

.title {
    font-size: 36px;
    font-weight: 600;
    line-height: 110%
}

.subtitle {
    font-size: 24px;
    font-weight: 500;
    line-height: 120%
}

.colorbg {
    background-color: #766aff
}

.hover:block:hover {
    display: block
}

.hover:border-gray-400:hover {
    --tw-border-opacity: 1;
    border-color: rgb(156 163 175/var(--tw-border-opacity))
}

.hover:bg-[#544AC0]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(84 74 192/var(--tw-bg-opacity))
}

.hover:bg-[#D2CFF1]:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(210 207 241/var(--tw-bg-opacity))
}

.hover:bg-gray-200:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(229 231 235/var(--tw-bg-opacity))
}

.hover:bg-light-purple:hover {
    --tw-bg-opacity: 1;
    background-color: rgb(235 234 253/var(--tw-bg-opacity))
}

.focus:border-purple:focus {
    --tw-border-opacity: 1;
    border-color: rgb(118 106 255/var(--tw-border-opacity))
}

.focus:outline-none:focus {
    outline: 2px solid transparent;
    outline-offset: 2px
}

.focus:ring-purple:focus {
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(118 106 255/var(--tw-ring-opacity))
}

// @media (prefers-color-scheme:dark) {
//     .dark:border-gray-600 {
//         --tw-border-opacity: 1;
//         border-color: rgb(75 85 99/var(--tw-border-opacity))
//     }

//     .dark:bg-gray-700 {
//         --tw-bg-opacity: 1;
//         background-color: rgb(55 65 81/var(--tw-bg-opacity))
//     }

//     .dark:bg-gray-800 {
//         --tw-bg-opacity: 1;
//         background-color: rgb(31 41 55/var(--tw-bg-opacity))
//     }

//     .dark:bg-slate-800 {
//         --tw-bg-opacity: 1;
//         background-color: rgb(30 41 59/var(--tw-bg-opacity))
//     }

//     .dark:text-white {
//         --tw-text-opacity: 1;
//         color: rgb(255 255 255/var(--tw-text-opacity))
//     }

//     .dark:hover:bg-gray-700:hover {
//         --tw-bg-opacity: 1;
//         background-color: rgb(55 65 81/var(--tw-bg-opacity))
//     }
// }
`;
